import React from "react";
import { useCachedCover } from "@/lib/projectApi";

/**
 * Renders a project cover image via the cached data-URL hook.
 * Falls back to the passed-in `fallback` node when there is no cover.
 */
export default function CoverImage({ projectId, coverId, alt = "", className = "", fallback = null }) {
  const url = useCachedCover(projectId, coverId);
  if (!coverId || !url) return fallback;
  return <img src={url} alt={alt} className={className} loading="lazy" />;
}
